import React from "react";
import { useLanguage, LANGUAGES } from "../i18n";

// Shown once, right after the boot splash, before anything else — so it
// can't assume a language yet. Text stays multi-script/self-describing
// rather than using t(), which would default to English before a choice
// is made.
export function LanguagePicker({ onDone }: { onDone: () => void }) {
  const { setLang } = useLanguage();

  function choose(code: (typeof LANGUAGES)[number]["code"]) {
    setLang(code);
    onDone();
  }

  return (
    <div className="center-col">
      <div className="content" style={{ paddingTop: 40, textAlign: "center" }}>
        <img src="/logo.svg" alt="ToLetBook" className="reg-logo" />
        <div className="reg-title" style={{ marginBottom: 24 }}>
          Select your language
        </div>
        <div className="chip-col">
          {LANGUAGES.map((l) => (
            <div key={l.code} className="chip" onClick={() => choose(l.code)}>
              {l.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
